export const WHITE = 'rgb(255, 255, 255)'
export const SNOW_WHITE = 'rgb(250, 250, 250)'
export const SILVER_GRAY = 'rgb(238, 238, 238)'
export const MERCURY_GRAY = 'rgb(233, 233, 233)'
export const NOBEL_GRAY = 'rgb(155, 155, 155)'
export const SPANISH_GRAY = 'rgb(148, 148, 148)'
export const STACK_GRAY = 'rgb(143, 143, 143)'
export const TROLLEY_GRAY = 'rgb(130, 130, 130)'
export const DOVE_GRAY = 'rgb(117, 117, 117)'
export const DIM_GRAY = 'rgb(101, 101, 101)'
export const BLACK = 'rgb(0, 0, 0)'
export const ARMADILLO_BLACK = 'rgb(74, 74, 74)'
export const CHARCOAL_BLACK = 'rgb(70, 70, 70)'
export const EERIE_BLACK = 'rgb(23 23 23)'

export const MAIN_RED = '#f15445'
export const PAGAMO_RED = '#ea6557'
export const DARK_PAGAMO_RED = '#e27367'
export const CORAL_RED = '#f94f4b'

export const PAGAMO_BLUE = '#6ed6d7'
export const LINK_BLUE = '#0074c2'

export const ICON_ORIGINAL_GRAY = '#8a8a8a'
